import styled, { ITheme } from '../../../../theme'

const Label = styled.div`
  position: relative;
  display: inline-block;
  margin: 0.25em 0;
  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};
  font-size: 1em;
  cursor: pointer;
`

export default Label
